import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.814 7.878v5.556c0 1.227 1.874 2.222 4.185 2.222 2.31 0 4.184-.995 4.184-2.222V7.878m-8.369 0C6.814 9.105 8.688 10.1 11 10.1c2.31 0 4.184-.995 4.184-2.222m-8.369 0c0-1.227 1.874-2.222 4.185-2.222 2.31 0 4.184.995 4.184 2.222m0 2.778c0 1.227-1.873 2.222-4.184 2.222s-4.185-.995-4.185-2.222",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M2.63 3.378c0-.583.473-1.055 1.056-1.055h14.627c.583 0 1.055.472 1.055 1.055v14.556c0 .583-.472 1.055-1.055 1.055H3.686a1.056 1.056 0 0 1-1.055-1.055V3.378z",
      stroke: "currentColor",
      "stroke-width": "1.056"
    }, null, -1)
  ]))]))
}
export default { render: render }